import { render, staticRenderFns } from "./TechnicalIcon.vue?vue&type=template&id=1494d6c1"
import script from "./TechnicalIcon.vue?vue&type=script&lang=js"
export * from "./TechnicalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports